(function () {
  const HIDE_DELAY = 240;

  function getHeaderBottom() {
    const header = document.querySelector('header-component');
    return header ? Math.round(header.getBoundingClientRect().bottom) : 88;
  }

  function setWrapperTop(wrapper) {
    wrapper.style.top = getHeaderBottom() + 'px';
  }

  function init() {
    const navItems = document.querySelectorAll('.custom-header__nav-item[data-mega-item]');
    if (!navItems.length) return;

    let hideTimer = null;
    let activeItem = null;

    function open(item) {
      clearTimeout(hideTimer);
      if (activeItem && activeItem !== item) close(activeItem, true);
      activeItem = item;
      scrollAnchor = window.scrollY;
      const wrapper = item.querySelector('.custom-header__mega-wrapper');
      if (wrapper) {
        setWrapperTop(wrapper);
        wrapper.removeAttribute('aria-hidden');
      }
      item.setAttribute('data-mega-open', '');
      const link = item.querySelector('.custom-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function close(item, immediate) {
      if (!item) return;
      function doClose(force) {
        if (!force) {
          const panel = item.querySelector('.okuma-mega-panel');
          if (item.matches(':hover') || (panel && panel.matches(':hover'))) return;
        }
        item.removeAttribute('data-mega-open');
        const link = item.querySelector('.custom-header__nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
        const wrapper = item.querySelector('.custom-header__mega-wrapper');
        if (wrapper) wrapper.setAttribute('aria-hidden', 'true');
        if (activeItem === item) activeItem = null;
        document.dispatchEvent(new CustomEvent('okuma-mega:close', { detail: { item } }));
      }
      if (immediate) {
        doClose(true);
      } else {
        hideTimer = setTimeout(doClose, HIDE_DELAY);
      }
    }

    navItems.forEach(function (item) {
      const panel = item.querySelector('.okuma-mega-panel');

      item.addEventListener('pointerenter', function () { open(item); });
      item.addEventListener('pointerleave', function () { close(item, false); });

      if (panel) {
        panel.addEventListener('pointerenter', function () { clearTimeout(hideTimer); });
        panel.addEventListener('pointerleave', function () { close(item, false); });
      }

      const link = item.querySelector('.custom-header__nav-link');
      if (link) {
        link.addEventListener('focus', function () {
          if (activeItem && activeItem !== item) close(activeItem, true);
        });

        link.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') close(item, true);
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (item.hasAttribute('data-mega-open')) {
              close(item, true);
            } else {
              open(item);
            }
          }
        });
      }
    });

    document.addEventListener('pointerdown', function (e) {
      if (activeItem && !activeItem.contains(e.target)) {
        close(activeItem, true);
      }
    });

    const SCROLL_CLOSE_THRESHOLD = 8;
    let scrollAnchor = window.scrollY;
    window.addEventListener('scroll', function () {
      if (!activeItem) {
        scrollAnchor = window.scrollY;
        return;
      }
      if (Math.abs(window.scrollY - scrollAnchor) >= SCROLL_CLOSE_THRESHOLD) {
        close(activeItem, true);
      }
    }, { passive: true });

    document.querySelectorAll('.custom-header__nav-item[data-mega-open] .custom-header__mega-wrapper').forEach(setWrapperTop);
  }

  function setMobileHeaderHeight() {
    document.documentElement.style.setProperty(
      '--okuma-mobile-header-height',
      getHeaderBottom() + 'px'
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      setMobileHeaderHeight();
      initMobileDrawer();
    });
  } else {
    init();
    setMobileHeaderHeight();
    initMobileDrawer();
  }

  window.addEventListener('resize', setMobileHeaderHeight, { passive: true });

  // Recalculate on scroll (RAF-throttled) so the drawer stays flush when
  // the announcement/utility rows have scrolled away and the sticky header
  // is at a different vertical position than on page load.
  let rafId = null;
  window.addEventListener('scroll', function () {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      setMobileHeaderHeight();
      rafId = null;
    });
  }, { passive: true });

  function initMobileDrawer() {
    const details = document.getElementById('Details-menu-drawer-container');
    if (!details) return;

    details.addEventListener('toggle', function () {
      if (details.open) setMobileHeaderHeight();
    });

    window.addEventListener('click', function (e) {
      const topSummary = details.querySelector(':scope > summary');
      if (!topSummary || !topSummary.contains(e.target)) return;
      if (details.hasAttribute('open')) e.preventDefault();
    }, { capture: true });

    const desktopMq = window.matchMedia('(min-width: 990px)');
    const closeOnDesktop = function (mq) {
      if (!mq.matches || !details.hasAttribute('open')) return;
      const drawer = details.closest('header-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      } else {
        details.removeAttribute('open');
      }
    };
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', closeOnDesktop);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(closeOnDesktop);
    }
  }
})();
